import { Button, Container, Grid, Typography } from "@material-ui/core";
import { useAuth } from "../../contexts/AuthContext";
import "./pageResponse.css";

const Page403Component = () => {
  const { logout } = useAuth();
  return (
    <>
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 1000,
          background: "linear-gradient(180deg, #010101 30%, #4a4a4a 180%)",
        }}
      >
        <div className="stars">
          <Container>
            <Grid container>
              <Grid>
                <img
                  src="http://salehriaz.com/404Page/img/earth.svg"
                  width="100px"
                  alt="earth"
                />
                <img
                  src="http://salehriaz.com/404Page/img/moon.svg"
                  width="80px"
                  alt="moon"
                />
              </Grid>
              <Grid>
                <img
                  src="http://salehriaz.com/404Page/img/rocket.svg"
                  width="40px"
                  alt="rocket"
                />
              </Grid>
            </Grid>
            <Grid container>
              <Grid container justifyContent="center" alignItems="center">
                <Grid item>
                  <Typography
                    align="center"
                    style={{
                      color: "white",
                      fontSize: "10rem",
                      fontWeight: 800,
                    }}
                    variant="h1"
                  >
                    403
                  </Typography>
                  <Typography
                    align="center"
                    style={{ color: "white", letterSpacing: "1em" }}
                  >
                    PAGE FOBIDDEN
                  </Typography>
                  <Typography
                    align="center"
                    style={{ color: "white", letterSpacing: "1em" }}
                  >
                    ERROR
                  </Typography>
                </Grid>
              </Grid>
              <Grid container justifyContent="center" alignItems="center">
                <Button
                  variant="outlined"
                  color="inherit"
                  onClick={logout}
                  style={{
                    marginTop: "25px",
                    color: "#FFCB39",
                    borderRadius: "20px",
                  }}
                >
                  Sign out
                </Button>
              </Grid>
            </Grid>
            <Grid style={{ marginLeft: "70%" }}>
              <img
                className="object_astronaut"
                src="http://salehriaz.com/404Page/img/astronaut.svg"
                width="140px"
                alt="astronaut"
              />
            </Grid>
          </Container>
        </div>
      </div>
    </>
  );
};

export default Page403Component;
